import { LucideIcon, Plus, Search } from "lucide-react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  isFiltered?: boolean;
  onClearFilter?: () => void;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  isFiltered,
  onClearFilter,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      {/* Icon */}
      <div className="w-16 h-16 rounded-2xl bg-stone-100 flex items-center justify-center mb-4">
        {isFiltered
          ? <Search className="w-7 h-7 text-stone-400" />
          : Icon
            ? <Icon className="w-7 h-7 text-stone-400" />
            : <div className="w-7 h-7 rounded-full bg-stone-300" />
        }
      </div>

      {/* Text */}
      <h3 className="text-base font-semibold text-stone-700 mb-1">
        {isFiltered ? "No results found" : title}
      </h3>
      <p className="text-sm text-stone-400 max-w-xs">
        {isFiltered
          ? "Try adjusting your search or filter to find what you're looking for."
          : description || "Nothing here yet. Get started by adding your first one."}
      </p>

      {/* Actions */}
      <div className="mt-5 flex items-center gap-3">
        {isFiltered && onClearFilter && (
          <button
            onClick={onClearFilter}
            className="px-4 py-2 rounded-xl text-sm font-medium text-stone-600 border border-stone-200 hover:bg-stone-50 transition-colors"
          >
            Clear filters
          </button>
        )}
        {!isFiltered && action && (
          <button
            onClick={action.onClick}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold text-white gold-gradient hover:opacity-90 transition-opacity"
          >
            <Plus className="w-4 h-4" />
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
